module.exports = __webpack_public_path__ + "img/default_car.4bd24fa8.jpg";